export enum FleetCategory {
  SEMI_TRUCK = 'semi-truck',
  STRAIGHT_TRUCK = 'straight-truck',
  VAN = 'van',
  SEMI_TRAILER = 'semi-trailer',
  TRAILER = 'trailer',
}
